import { BmHttp as Http } from "../utils/Global";

export const PostNewPromocion = async(payload) => {
    try {

        const { data } = await Http().post(`promocion`, payload);
        return data;
        
    } catch (error) {
        return error.response.data;
    }
}

// SEGUROS-PLANES-P1: `params` opcional { seguro_id }. Sin el parametro la
// llamada es EXACTAMENTE la de siempre (todas las promociones Activas de la
// clinica) -- por eso los consumidores existentes no cambian ni una linea.
// Con `seguro_id` el servidor filtra y devuelve solo las de esa aseguradora.
export const ListadoPromocion = async(params = {}) => {
    try {

        const { data } = await Http().get(`promocion`, { params });
        return data;

    } catch (error) {
        return error.response.data;
    }
}
export const EliminarPromocion = async (id) => {
    try {
        const { data } = await Http().post(`promocion-eliminar`, { id_promocion: id });
        return data;
    } catch (error) {
        return error.response.data;
    }
};

export const getPromocionPorId = async (id) => {
    try {
        //alert(id);
        const { data } = await Http().get(`promocion-edit/${id}`);
        return data;
    } catch (error) {
        return error.response.data;
    }
}

export const actualizarPromocion = async(payload) => {
    try {

        const { data } = await Http().post(`promocion-actualizar`, payload);
        return data;
        
    } catch (error) {
        return error.response.data;
    }
}